import Grid from '@mui/material/Grid';
import { Field } from 'formik';
import { FormTextField } from '../FormTextField';

function SoftDescriptor() {
  return (
    <>
      <Grid  size={12}>
        <Field name="softDescriptor" component={FormTextField} type="text" placeholder="Soft descriptor" />
      </Grid>
      <Grid  size={12} className="soft-descriptor">
        El Soft Descriptor es el texto que verá el cliente en el estado de cuenta de su tarjeta o banco.
      </Grid>
    </>
  );
}

export default SoftDescriptor;
